import { useNavigate } from 'react-router-dom'

const Check = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <circle cx="10" cy="10" r="10" fill="#4cbc18" />
    <path
      d="M6 10.5l2.5 2.5L14 7.5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const Arrow = () => (
  <svg width="17" height="12" viewBox="0 0 17 12" fill="none">
    <path
      d="M11 1l5 5-5 5M16 6H1"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const CallToAction = () => {
  const navigate = useNavigate()

  return (
    <section className="relative overflow-hidden bg-brand-dark">
      <div
        className="absolute left-[22%] top-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(76,188,24,0.20), transparent 70%)' }}
      />
      <div
        className="absolute right-[12%] top-[60%] w-[140px] h-[140px] rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(76,188,24,0.18), transparent 70%)' }}
      />

      <div className="relative z-10 max-w-canvas mx-auto px-[120px] py-[100px] flex flex-col items-center">
        <h2 className="text-[44px] leading-[52px] font-extrabold text-white text-center">
          Make Every Deal a{' '}
          <span className="text-brand-green">Calculated Decision</span>
        </h2>

        <div className="mt-10 flex items-center gap-4">
          <button
            type="button"
            onClick={() => navigate('/pricing')}
            className="h-[56px] px-8 rounded-full border border-brand-green text-white text-[16px] font-semibold"
          >
            View Full Pricing
          </button>

          <button
            type="button"
            onClick={() => navigate('/signup')}
            className="h-[56px] px-8 rounded-full bg-brand-green text-white text-[16px] font-semibold inline-flex items-center gap-2"
          >
            Start 7-Day Free Trial
            <Arrow />
          </button>
        </div>

        <div className="mt-6 flex items-center gap-8 text-white text-[14px]">
          <span className="flex items-center gap-2">
            <Check />
            No credit card required
          </span>
          <span className="flex items-center gap-2">
            <Check />
            Start in seconds
          </span>
        </div>
      </div>
    </section>
  )
}

export default CallToAction
